<template>
  <div>
    <div class="modal" v-if="!baseDataLoaded">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          Preparing Application - Please Wait ...
        </div>
      </div>
    </div>
    <div v-else>
      <app-header></app-header>
      <router-view></router-view>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

import AppHeader from "./components/layout/AppHeader.vue";
import AppFooter from "./components/layout/AppFooter.vue";

export default {
  components: { AppHeader, AppFooter },

  setup() {
    const store = useStore();

    const baseDataLoaded = ref(false);

    axios.interceptors.request.use(request => {
      const activeUser = store.getters['user'];
      if (activeUser && activeUser.organizationUuid) {
        request.headers['vtmx-organization-id'] = activeUser.organizationUuid;
      }
      return request;
    });

    onMounted(function() {
      store.dispatch('loadBaseData');
    });

    watch(() => store.getters['loadingBaseData'], function(newData) {
      if (!newData) {
        baseDataLoaded.value = true;
      }
    });

    return {
      baseDataLoaded
    };
  },
}
</script>

<style>
.vina-center {
  text-align: center;
  margin: auto;
  width: 50%;
  padding: 10px;
}
.vina-indent-1 {
  margin-left: 300px;
}
.vina-is-clickable {
  cursor: pointer;
}
</style>